module.exports = __webpack_public_path__ + "static/media/YellowStroke10.a1192488.svg";